import React from 'react';
import { CircleAlert, X } from 'lucide-react';

interface ConnectAccountBannerProps {
    onClose: () => void;

    // Dynamic Content
    title: string;
    description: string;
    actionLabel: string;
    onAction: () => void;
    variant?: 'default' | 'compact';
}

const ConnectAccountBanner: React.FC<ConnectAccountBannerProps> = ({
    onClose,
    title,
    description,
    actionLabel,
    onAction,
    variant = 'default',
}) => {
    const isCompact = variant === 'compact';

    return (
        <div className={`w-full bg-[#FFFBEB] border border-[#FEF3C7] rounded-lg flex justify-between ${isCompact ? 'items-center gap-3 px-3 py-2 shadow-sm sm:gap-4 sm:px-4 sm:py-3' : 'items-start gap-6 p-6 mb-6'}`}>

            {/* Left Section: Icon + Text */}
            <div className={`flex min-w-0 ${isCompact ? 'items-center gap-2 sm:gap-3' : 'items-start gap-4 max-w-[888px]'}`}>
                {/* Icon aligned at top-left with mt-0.5 to match text cap-height */}
                <CircleAlert className={`${isCompact ? 'h-4 w-4' : 'w-6 h-6 mt-0.5'} text-gray-800 shrink-0`} />

                <div className={`flex min-w-0 flex-col ${isCompact ? 'justify-center' : 'gap-0.5'}`}>
                    <h3 className={`truncate font-sans font-semibold text-gray-900 ${isCompact ? 'text-sm leading-5 sm:text-base' : 'text-base leading-6'}`}>
                        {title}
                    </h3>
                    <p className={`font-sans font-normal text-gray-600 ${isCompact ? 'hidden text-xs leading-4 sm:block sm:text-sm sm:leading-5' : 'text-sm leading-5'}`}>
                        {description}
                    </p>
                </div>
            </div>

            {/* Right Section: Button + Close */}
            {/* 2. Added 'mt-0.5' to match the Icon's top alignment perfectly */}
            <div className={`flex shrink-0 ${isCompact ? 'items-center gap-2' : 'items-start gap-4 mt-0.5'}`}>
                <button
                    onClick={onAction}
                    className={`${isCompact ? 'h-8 w-auto px-3 text-sm leading-none' : 'w-[188px] h-12 text-[16px]'} bg-white border border-gray-300 shadow-sm text-gray-700 font-medium rounded-md hover:bg-gray-50 transition-colors flex items-center justify-center`}
                >
                    {actionLabel}
                </button>

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className={`${isCompact ? 'flex h-8 w-8 items-center justify-center p-0' : 'p-1'} text-gray-600 hover:text-gray-800 transition-colors`}
                    aria-label="Close banner"
                >
                    <X className={isCompact ? 'h-4 w-4' : 'w-6 h-6'} />
                </button>
            </div>
        </div>
    );
};

export default ConnectAccountBanner;
